import { matchPath, useLocation } from 'react-router';

/**
 * Хук для определения, нужно ли отображать webim
 * @returns true, если нужно скрыть на странице
 */
export const useIsChatHidden = (): boolean => {
  const hiddenPages = ['dashboard'];
  const hiddenPaths = [
    '/:role/settings/event-types/create',
    '/:role/settings/event-types/:id/edit',
  ];

  const location = useLocation();

  const isHidden =
    hiddenPages.some((page) => location.pathname.endsWith(page)) ||
    hiddenPaths.some((path) =>
      matchPath({ path, end: true }, location.pathname),
    );

  return isHidden;
};
